// extracted by mini-css-extract-plugin
export default {"btn":"SignUpButton_btn__HghPA"};